import { Store } from 'rxjs-observable-store';
import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { StoreRequestStateUpdater } from '../../../shared/types/store-request-state-updater';
import * as endpointHelpers from '../../../shared/helpers/endpoint.helpers';
import { MainStoreState } from './main.store.state';
import { MainEndpoint } from './main.endpoint';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class MainStore extends Store<MainStoreState> implements OnDestroy {
  private ngUnsubscribe$: Subject<undefined> = new Subject();
  private storeRequestStateUpdater: StoreRequestStateUpdater;

  constructor(private endpoint: MainEndpoint) {
    super(new MainStoreState());
  }

  init(): void {
    this.storeRequestStateUpdater = endpointHelpers.getStoreRequestStateUpdater(this);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  getServerVersion() {
    return this.endpoint.getServerVersion(this.storeRequestStateUpdater).pipe(takeUntil(this.ngUnsubscribe$));
  }
}
